export default {
    data() {
        return {
            termDetails: {
                profit_distribution_year: years[0],
                waiver_of_notice: '31.12.' + ((new Date).getFullYear() + 3),
                general_present_quorum: termDetailValues.general_present_quorum.recommended,
                individual_presence_quorum: termDetailValues.individual_presence_quorum.recommended,

                profit_distribution: termDetailValues.profit_distribution.recommended,
                reserve_obligation: termDetailValues.reserve_obligation.recommended,
                free_availability: termDetailValues.free_availability.recommended,

                director_from_general_assembly: true,
                director_from_supervisory_board: true,
                merging_conversion: termDetailValues.merging_conversion.recommended,
                abandonment_resolutions_significant: termDetailValues.abandonment_resolutions_significant.recommended,
                resolutions_amendment: termDetailValues.resolutions_amendment.recommended,
                business_transfers_resolutions: termDetailValues.business_transfers_resolutions.recommended,
                investments_approval: termDetailValues.investments_approval.recommended,
                decisions_on_mergers: termDetailValues.decisions_on_mergers.recommended,
                managing_directors_resolution: termDetailValues.managing_directors_resolution.recommended,
                voluntary_establishment_resolution: termDetailValues.voluntary_establishment_resolution.recommended,
                advisory_board_voluntary_decisions: termDetailValues.advisory_board_voluntary_decisions.recommended,
                examination_regulations_resolutions: termDetailValues.examination_regulations_resolutions.recommended,
                share_loss_resolution: termDetailValues.share_loss_resolution.recommended,
                lawsuits_initiate_decisions: termDetailValues.lawsuits_initiate_decisions.recommended,
                profit_distribution_decisions: termDetailValues.profit_distribution_decisions.recommended,
                business_transactions_approval_resolution: termDetailValues.business_transactions_approval_resolution.recommended,
                contracts_conclusion_decisions: termDetailValues.contracts_conclusion_decisions.recommended,
                partners_admission_resolution: termDetailValues.partners_admission_resolution.recommended,
                companies_acquisition_resolution: termDetailValues.companies_acquisition_resolution.recommended,
                company_dissolve_resolution: termDetailValues.company_dissolve_resolution.recommended,
                settlement_days: termDetailValues.settlement_days.recommended,
                transaction_time: termDetailValues.transaction_time.recommended,
                sales_compensation: termDetailValues.sales_compensation.recommended,
                inheritance_compensation: termDetailValues.inheritance_compensation.recommended,
                reaction_days: termDetailValues.reaction_days.recommended,
                outbid: termDetailValues.outbid.recommended,
            },
            distributionYears: years,
        };
    },
    computed: {
        resolutionGroupMin() {
            return this.termDetails.managing_directors_resolution;
        },
        reserveObligationMax() {
            return 100 - this.termDetails.profit_distribution;
        },
        individualPresenceQuorumMin() {
            return this.partnerMaxShare > 10 ? this.partnerMaxShare - 10 : 0;
        },
        freeAvailability() {
            const maxVal = 100 - this.termDetails.profit_distribution - this.termDetails.reserve_obligation;

            return maxVal >= 0 ? maxVal : 0;
        },
    },
    watch: {
        'termDetails.profit_distribution': function () {
            if ((this.termDetails.profit_distribution + this.termDetails.reserve_obligation) > 100) {
                this.termDetails.reserve_obligation = 100 - this.termDetails.profit_distribution;
            }
        },
        'termDetails.reserve_obligation': function () {
            if ((this.termDetails.profit_distribution + this.termDetails.reserve_obligation) > 100) {
                this.termDetails.profit_distribution = 100 - this.termDetails.reserve_obligation;
            }
        },
        'termDetails.sales_compensation' : function () {
            this.termDetails.inheritance_compensation = this.termDetails.sales_compensation;
        },
    },
};
